import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";

const CATS = [
  { key: "funcionalidad", t: "Funcionalidad", d: "Imprescindibles para que la web funcione: inicio de sesión, seguridad y guardar tu elección de cookies.", fija: true },
  { key: "preferencias", t: "Preferencias", d: "Recuerdan tus elecciones en la web (por ejemplo, tus preferencias de visualización)." },
  { key: "marketing", t: "Marketing", d: "Permiten personalizar comunicaciones y publicidad según tus intereses." },
  { key: "medicion", t: "Medición", d: "Nos ayudan a entender cómo se usa la web para mejorarla (analítica con PostHog)." },
];

export function CookieSettingsDialog({ open, onOpenChange, initial, onSave }) {
  const [prefs, setPrefs] = useState(initial);
  useEffect(() => { if (open) setPrefs(initial); }, [open, initial]);
  const todo = (v) => onSave({ preferencias: v, marketing: v, medicion: v });
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto rounded-3xl border-2 border-[#0A2540] bg-[#F0FDF8]" data-testid="cookie-settings-dialog">
        <DialogTitle className="flex items-center gap-2 font-heading text-xl font-extrabold text-[#0A2540]"><Cookie className="w-5 h-5 text-emerald-600" /> Configuración de cookies</DialogTitle>
        <DialogDescription className="text-sm text-slate-600">
          Elige qué cookies aceptas. Puedes cambiarlo cuando quieras desde el enlace «Configurar cookies» del pie de página. <Link to="/legal/cookies" onClick={() => onOpenChange(false)} className="font-semibold text-emerald-700 underline" data-testid="cookie-settings-policy-link">Política de cookies</Link>
        </DialogDescription>
        <div className="space-y-2.5">
          {CATS.map((c) => (
            <div key={c.key} className="flex items-start justify-between gap-4 rounded-2xl border border-[#0A2540]/15 bg-white p-4" data-testid={`cookie-cat-${c.key}`}>
              <div>
                <p className="font-semibold text-[#0A2540] text-sm">{c.t} {c.fija && <span className="ml-1 text-[10px] font-bold uppercase tracking-wide text-emerald-700">Siempre activas</span>}</p>
                <p className="text-xs text-slate-500 mt-0.5 leading-relaxed">{c.d}</p>
              </div>
              <Switch checked={c.fija ? true : !!prefs?.[c.key]} disabled={c.fija} onCheckedChange={(v) => setPrefs({ ...prefs, [c.key]: v })}
                className="mt-0.5 data-[state=checked]:bg-emerald-500" data-testid={`cookie-toggle-${c.key}`} />
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 pt-1">
          <Button variant="outline" onClick={() => todo(false)} className="rounded-full border-[#0A2540] text-[#0A2540]" data-testid="cookie-settings-reject">Rechazar todo</Button>
          <Button variant="outline" onClick={() => onSave(prefs)} className="rounded-full border-[#0A2540] text-[#0A2540]" data-testid="cookie-settings-save">Guardar selección</Button>
          <Button onClick={() => todo(true)} className="rounded-full bg-emerald-500 hover:bg-emerald-600 text-white" data-testid="cookie-settings-accept">Aceptar todo</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
